import { Play, Pause, CalendarCheck, GitCommitVertical } from 'lucide-react';
import { Badge } from '@/components/ui/Badge';

interface StatusBadgeProps {
  is_ai_disabled: boolean;
  msg_count_24h?: number;
  teve_reativacao_recente?: boolean;
  className?: string;
}

export function StatusBadge({ is_ai_disabled, msg_count_24h = 0, teve_reativacao_recente, className }: StatusBadgeProps) {
  if (is_ai_disabled) {
    return (
      <Badge variant="danger" className={className} title="IA desligada — atendimento humano ativo">
        <Pause className="h-3 w-3 mr-1" />
        IA Desligada
      </Badge>
    );
  }

  if (teve_reativacao_recente) {
    return (
      <Badge variant="info" className={className} title="Reunião/interação recente agendada">
        <CalendarCheck className="h-3 w-3 mr-1" />
        Reunião
      </Badge>
    );
  }

  if (msg_count_24h > 0) {
    return (
      <Badge variant="success" className={className} title="IA ativa e respondendo">
        <Play className="h-3 w-3 mr-1" />
        IA Ativa
      </Badge>
    );
  }

  return (
    <Badge variant="default" className={className} title="Inativo há mais de 24h">
      <GitCommitVertical className="h-3 w-3 mr-1" />
      Inativo
    </Badge>
  );
}
